<template>
  <el-card shadow="never" class="aui-card--fill">
    <div>
      <h2 class="title">商户账号资料</h2>
      <el-form :model="infoList" ref="dataForm" label-width="220px" justify="center">
        <h3>用户基本资料</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="username" label="登录账号：">
              <span>{{infoList.username}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="mobile" label="手机号：">
              <span>{{infoList.mobile}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="realName" label="姓名：">
              <span>{{infoList.realName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="email" label="邮箱：">
              <span>{{infoList.email}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <h3>商户基本信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="personName" label="商户名称：">
              <span>{{infoList.personName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="approveMerchantInfo" label="业务类型：">
              <span>惠扶绥商城</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="personUserName" label="法人姓名：">
              <span>{{infoList.personUserName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="businessLicenseFrontUrl" label="营业执照：">
              <el-image :src="infoList.businessLicenseFrontUrl"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="personTelephone" label="联系方式  ：">
              <span>{{infoList.personTelephone}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10" v-if="type==1">
            <el-form-item prop="roleIdList" label="商户角色：">
              <template>
                <div v-for="item in roleList" :key="item.id" class="role">{{item.name}}</div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <h3>收款账户信息</h3>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="card" label="收款资金账户：">
              <span>{{infoList.card}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="remarks" label="备注：">
              <span>{{infoList.remarks}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align:center">
        <el-button @click="$router.push({name:'mallRegister',query:{record:3}})">返回</el-button>
        <el-button
          type="primary"
          @click="examineHandle"
          v-if="this.infoList.tanantState==1&&type==2"
        >审核</el-button>
      </div>

      <el-dialog title="审核" :visible.sync="dialogVisible" width="30%">
        <el-form :model="curForm" label-width="90px">
          <el-form-item label="审核：">
            <el-radio-group v-model="curForm.tanantState">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="请输入角色" class="role-list">
            <el-select v-model="curForm.roleIdList" multiple placeholder="请输入角色">
              <el-option
                v-for="role in roleList2"
                :key="role.id"
                :label="role.name"
                :value="role.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="备注："
            :rules="[
      { required: true, message: '备注不能为空'}]"
            v-if="curForm.tanantState == '2'"
          >
            <el-input v-model="curForm.tanantRemark" type="textarea" placeholder="请输入备注" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="audit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
// import Cookies from "js-cookie";
// import debounce from "lodash/debounce";
export default {
  data() {
    return {
      infoList:{},
      roleList2: [],
      roleList: [],
      dialogVisible: false,
      visible: false,
      type: null,
      curForm: {
        id: "",
        tanantState: "1",
        tanantRemark: "",
        roleIdList: []
      },
      src:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      radio: 1
    };
  },
  // watch: {
  //   $route: {
  //     handler(val, oldval) {
  //       this.type = this.$route.query.type;
  //       console.log(this.type);
  //     }
  //   }
  // },
  created() {
    this.type = this.$route.query.type;

    // this.getInfo(this.$route.query.id);
    this.getRegistInfo(this.$route.query.id);
  },
  methods: {
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo(this.dataForm.id);
        }
      });
    },
    // 获取角色列表
    getRoleList() {
      return this.$http
        .get("/sys/tenant/role/tenantList")
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.roleList2 = res.data;
          this.dataForm.roleIdList.forEach(item => {
            res.data.forEach(item2 => {
              if (item == item2.id) {
                this.roleList.push(item2);
              }
            });
          });

          console.log(this.roleList);
        })
        .catch(() => {});
    },
    // 审核弹窗
    examineHandle() {
      var id = this.$route.query.id;
      console.log(id);
      this.curForm = {
        id,
        tanantState: "1",
        tanantRemark: "",
        roleIdList: []
      };
      this.dialogVisible = true;
    },
    // 审核
    audit() {
      this.$http
        .post("/sys/approvemerchantinfo/merchantCheck", this.curForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dialogVisible = false;
          this.$message.success(res.msg);
          this.query();
          this.$router.back();
        });
    },
    //获取商户全部信息
    async getRegistInfo(id) {
      const res1 = await this.$request.post("/approver-api/api/web/approvemerchantconfig/info",{infoId: id});

      const res2 = await this.$request.post("/approver-api/api/web/approvemerchantinfo/info",{infoId: res1.data.infoId});

      const res3 = await this.$request.post("/approver-api/api/web/approvetenantinformation/info",{tenantInformationId: res2.data.tenantInformationId});

      this.infoList={...res1.data,...res2.data,...res3.data}

      console.log(this.infoList)
    },
    //获取其商户信息
    getChantInfo(infoId) {
      this.$request
        .post("/approver-api/api/web/approvemerchantinfo/info", {
          infoId: infoId
        })
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }

          this.getBaseInfo(res.data.tenantInformationId);
        });
    },
    //获取基本信息
    getBaseInfo(tenantInformationId) {
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/info", {
          tenantInformationId: tenantInformationId
        })
        .then(res => {
          if (!res.code) {
            return this.$message.error(res.msg);
          }
        });
    },
    // 获取信息
    getInfo(id) {
      this.$http
        .post("/sys/approvemerchantinfo/info", { id })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = res.data;

          this.getRoleList();
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
h3 {
  padding-left: 30px;
}

.el-image {
  height: 50px;
  width: 80px;
  img {
    width: 100%;
  }
}

.role {
  border: 1px solid #ccc;
  text-align: center;
  border-radius: 5px;
  float: left;
  margin-left: 2px;
  font-size: 12px;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
}

</style>
